import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("i", { class: "fa fa-list p-mr-2" }, null, -1)
const _hoisted_2 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_3 = { class: "p-field p-col-12 p-lg-6" }
const _hoisted_4 = { class: "p-field p-col-12 p-lg-6" }
const _hoisted_5 = { class: "p-float-label" }
const _hoisted_6 = { class: "kn-material-input-label" }
const _hoisted_7 = { class: "p-field p-col-6" }
const _hoisted_8 = { class: "p-field p-col-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Button = _resolveComponent("Button")
  const _component_HierarchyManagementDimensionsFilterCard = _resolveComponent("HierarchyManagementDimensionsFilterCard")
  const _component_HierarchyManagementDimensionsTable = _resolveComponent("HierarchyManagementDimensionsTable")
  const _component_Card = _resolveComponent("Card")
  const _component_HierarchyManagementHierarchyMasterDialog = _resolveComponent("HierarchyManagementHierarchyMasterDialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Card, { class: "p-m-2 p-d-flex p-flex-column hierarchy-scrollable-card" }, {
      header: _withCtx(() => [
        _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
          start: _withCtx(() => [
            _hoisted_1,
            _createVNode("span", null, _toDisplayString(_ctx.$t('managers.hierarchyManagement.dimensions')), 1)
          ]),
          _: 1
        })
      ]),
      content: _withCtx(() => [
        _createVNode("form", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_Calendar, {
              class: "kn-material-input",
              modelValue: _ctx.validityDate,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.validityDate = $event)),
              manualInput: true,
              showIcon: true,
              onDateSelect: _ctx.onValidityDateSelected
            }, null, 8, ["modelValue", "onDateSelect"])
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode("span", _hoisted_5, [
              _createVNode(_component_Dropdown, {
                class: "kn-material-input",
                modelValue: _ctx.selectedDimension,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedDimension = $event)),
                options: _ctx.dimensions,
                optionLabel: "DIMENSION_NM",
                onChange: _ctx.onSelectedDimensionChange
              }, null, 8, ["modelValue", "options", "onChange"]),
              _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('managers.hierarchyManagement.dimensions')), 1)
            ])
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode(_component_Button, {
              class: "kn-button kn-button--primary kn-truncated",
              label: _ctx.$t('managers.hierarchyManagement.createHierarchyMaster'),
              disabled: !_ctx.selectedDimension,
              onClick: _ctx.openHierarchyMasterDialog
            }, null, 8, ["label", "disabled", "onClick"])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_Button, {
              class: "kn-button kn-button--primary",
              label: _ctx.$t('managers.hierarchyManagement.synchronize'),
              disabled: _ctx.synchronizeButtonDisabled,
              onClick: _ctx.synchronize
            }, null, 8, ["label", "disabled", "onClick"])
          ])
        ]),
        _withDirectives(_createVNode(_component_HierarchyManagementDimensionsFilterCard, {
          dimensionFilters: _ctx.dimensionFilters,
          selectedHierarchy: _ctx.selectedHierarchy,
          onApplyFilters: _ctx.onApplyFilters
        }, null, 8, ["dimensionFilters", "selectedHierarchy", "onApplyFilters"]), [
          [_vShow, _ctx.selectedDimension]
        ]),
        _withDirectives(_createVNode(_component_HierarchyManagementDimensionsTable, { dimensionData: _ctx.dimensionData }, null, 8, ["dimensionData"]), [
          [_vShow, _ctx.dimensionData]
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_HierarchyManagementHierarchyMasterDialog, {
      visible: _ctx.hierarchyMasterDialogVisible,
      nodeMetadata: _ctx.nodeMetadata,
      dimensionMetadata: _ctx.dimensionMetadata,
      validityDate: _ctx.validityDate,
      selectedDimension: _ctx.selectedDimension,
      dimensionFilters: _ctx.dimensionFilters,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.hierarchyMasterDialogVisible = false)),
      onMasterHierarchyCreated: _ctx.onMasterHierarchyCreated
    }, null, 8, ["visible", "nodeMetadata", "dimensionMetadata", "validityDate", "selectedDimension", "dimensionFilters", "onMasterHierarchyCreated"])
  ], 64))
}